import { useFormikContext } from 'formik';
import Switch from '@mui/material/Switch';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

interface FormFieldProps {
  name: string;
  value?: any;
  trueValue?: any;
  falseValue?: any;
  label?: string;
  onChange?: (value: any) => void;
}

export const SwitchContainer = <T extends {}>(props: FormFieldProps) => {
  const { setFieldValue } = useFormikContext<T>()

  const handleChange = (checked: boolean) => {
    const value = (props.trueValue && props.falseValue) ? (checked ? props.trueValue : props.falseValue) : checked
    setFieldValue(props.name, value);
    if (props.onChange) {
      props.onChange(value)
    }
  }

  const checked = (props.trueValue && props.falseValue) ? props.trueValue === props.value : props.value

  if (props.label) {
    return (
      <FormGroup>
        <FormControlLabel control={<Switch color="primary" checked={checked} onChange={(e, value) => handleChange(value)} />} label={props.label} />
      </FormGroup>
    )
  }
  return (
    <Switch color="primary" checked={checked} onChange={(e, value) => handleChange(value)} />
  )
}

export default SwitchContainer